<template>
  <h4 id="nav-title" class="m-0">{{ title }}</h4>
</template>

<script lang="ts">
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'NavbarCenterItem',
  props: {
    title: String
  }

});
</script>
<style scoped>
#nav-title {
  font-size: 1.2rem;
}
</style>
